import { createSelector } from "reselect";
import { API_URL } from "utils/constants";

export function getAiVersionGenerationEnabled(state){
	return state.advertiserDetails?.data?.aiGeneration?.isVersionGenerationEnabled;
}

function getLibraryId(state){
	return state.libraryProperties.id;
}

function getCreatives(state){
	return state.versionGeneration.creatives;
}

function getSourceVersions(state){
	return state.versionGeneration.sourceVersions;
}

function buildDisplayData(libraryId, creatives, sourceVersions){
	/*
		We need a combination of creative and variable data to be able to render
		previews using ftUtils.

		This patches together the relevant data, so we can easily plug in the AI generated
		variables later.
	*/
	return creatives.map((creative, index) => {
		const sourceVersion = sourceVersions.find(version => version.creative?.id === creative.id);
		const { routeFile } = creative;
		return {
			creative: {
				id: creative.id,
				name: creative.name,
				adType: creative.adType,
				creativeLibrary: {
					id: libraryId,
				},
				baseAsset: {
					host: API_URL,
					path: `/crm/v1/asset-manager/${libraryId}/${creative.id}/`,
					file: `${routeFile}?download=false`,
				},
				height: creative.height,
				width: creative.width,

				version: {
					...sourceVersion?.variableConfig,
				},
			},
			placement: {
				id: `${creative.id}${index}`,
			},
		};
	});
}

export const getDisplayData = createSelector([getLibraryId, getCreatives, getSourceVersions], buildDisplayData);
